import { useParams } from 'react-router-dom'
import { usePreferences } from 'context/preferences/PreferencesContext'
import { ContactCompanyType } from 'models/contact_companies'
import { getIdWithPrefix } from 'utils/pathUtils'
import { useGetK12District } from 'services/k12'
import LoadingScreen from 'components/Layout/LoadingScreen'
import useDocumentTitle from 'components/useDocumentTitle'
import {
  MobileCompanyPageShell,
  MobileCompanyNotFound,
} from 'components/MobileCompanyPage/MobileCompanyPageShell'
import { buildK12PageContent } from './companyTypeData'

export function MobileK12Page() {
  const urlParams = useParams()
  const { preferences } = usePreferences()
  const k12DistrictID = urlParams?.k12_id
    ? getIdWithPrefix(
        urlParams.k12_id,
        preferences?.company_type_prefix_map[ContactCompanyType.K12District]
      )
    : undefined

  const { data, isLoading } = useGetK12District(k12DistrictID)

  // Shared derivation — same stats/fields as the desktop NewK12DistrictPage.
  const content = buildK12PageContent(data)
  useDocumentTitle(isLoading ? 'Loading...' : content.documentTitle)

  if (isLoading) {
    return <LoadingScreen />
  }

  if (!data || !content.contactCompanyId) {
    return <MobileCompanyNotFound label="K12 District not found" />
  }

  return (
    <MobileCompanyPageShell
      contactCompanyId={content.contactCompanyId}
      companyName={content.header.name}
      domain={content.header.domain}
      summaryContent={content.summaryContent}
      locationDetailsContent={content.locationDetailsContent}
    />
  )
}
